module.exports = __webpack_public_path__ + "img/cbam-1-en.bce4eede.png";